export enum EXERCISE_STATUS {
	STUDYING = 0,
	SUBMITTED = 1,
	PREVIOUS_RESULT = 2,
}
